import React from "react";
import ContentDetailPage from "@/components/ContentDetailPage";

export default function CaseReportDetail() {
  return (
    <ContentDetailPage
      routeBase="/case-reports"
      backLabel="Back to case reports"
      testIdPrefix="case"
    />
  );
}
